<template>
  <div class="p-8">
    <div class="flex flex-col shadow-md rounded-lg mx-4 border border-red-600 max-w-md mx-auto">
      <div class="border-red-600 border-b bg-red-400 text-red-800 font-bold py-2 px-4 text-center rounded-t-lg">
          Negocio no encontrado
      </div>
      <p class="text-6xl text-center text-yellow-600 mt-4">
          <i class="fas fa-exclamation-triangle"></i>            
      </p>
      <div class="p-4 border-l border-r border-b border-b-gray-800 rounded-b-lg text-gray-800 text-center">
          No pudimos encontrar el negocio al que estás intentando acceder. Por favor, verifica la dirección web ingresada e inténtalo nuevamente.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaceNotFound'
}
</script>

<style scoped lang="scss">

</style>
